import React from "react";
import { AtticusForm } from "../../models/AtticusForm";
import { Box, Card, CardActionArea } from "@mui/material";
import genericFormSrc from "../../assets/generic-form.svg";
import { SxProps, Theme } from "@mui/material";

interface Props {
  form: AtticusForm;
  onClick: null | ((e: React.MouseEvent<HTMLElement>) => void);
  sx: null | SxProps | SxProps<Theme>;
}

export const FormThumbnail = ({ form, onClick, sx }: Props): JSX.Element => {
  const rootStyles = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    transition: onClick ? "all 0.2s ease-in-out !IMPORTANT" : undefined,
    "&:hover": {
      scale: onClick ? "1.025" : undefined,
    },
  };

  return (
    <>
      <Box sx={sx ? { ...rootStyles, ...sx } : rootStyles}>
        <Box
          component={Card}
          sx={{
            width: "inherit",
            objectFit: "contain",
            borderRadius: "0px",
            overflow: "hidden",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <CardActionArea
            onClick={onClick || undefined}
            disableRipple={onClick ? false : true}
            // disabled={onClick ? false : true}
            sx={{
              display: "flex",
              height: "100%",
              clear: "both",
            }}
          >
            <img
              style={{
                height: "100%",
                width: "100%",
              }}
              src={
                form.s3Urls?.thumbnailFile
                  ? form.s3Urls.thumbnailFile
                  : genericFormSrc
              }
              alt={
                form.s3Urls?.thumbnailFile
                  ? `Thumbnail of ${form.geography?.fullName} Form ${form.title}`
                  : `Generic Form Thumbnail`
              }
              title={form.title.atticus || ""}
            />
          </CardActionArea>
        </Box>
      </Box>
    </>
  );
};
